import { Box } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import ParameterValue from "../../../api/models/test-series/ParameterValue";
import { CustomSelectableChip } from "../../Chip/CustomSelectableChip";

export interface MultiParamUnitSelectorProps {
  sharedUnitParams?: ParameterValue[];
  onSelectionChanged: Dispatch<SetStateAction<ParameterValue[]>>;
}

const MultiParamUnitSelector: React.FC<MultiParamUnitSelectorProps> = (props: MultiParamUnitSelectorProps) => {
  const { sharedUnitParams, onSelectionChanged } = props;
  const [selected, setSelected] = useState<ParameterValue[]>([]);
  const [showChips, setShowChips] = useState<boolean>(false);

  useEffect(() => {
    onSelectionChanged(selected);
  }, [selected]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setShowChips(event.target.checked);
    setSelected([]);
  };
  const instruction = "Click on chip to select or deselect.";
  const labelText = `Apply unit on further properties. ${showChips ? instruction : ""}`;

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <FormControlLabel control={<Checkbox color="primary" onChange={handleCheckboxChange} />} label={labelText} />
        </Grid>
      </Grid>
      {showChips && (
        <Grid item xs={12}>
          <Box>
            {sharedUnitParams &&
              sharedUnitParams.map((parameterValue) => (
                <Box display="inline-block" key={parameterValue.parameter.tmbId} margin={1}>
                  <CustomSelectableChip
                    isSelected={selected.map((s) => s.parameter.tmbId).includes(parameterValue.parameter.tmbId)}
                    parameterValue={parameterValue}
                    setSelected={setSelected}
                  />
                </Box>
              ))}
          </Box>
        </Grid>
      )}
    </>
  );
};

export default MultiParamUnitSelector;
